import { Button } from "@mozioinc/ui";
import { captureException } from "@sentry/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ErrorSvg from "./assets/error.svg?react";
import { PreservedLink } from "./preserved-link";
import type { TransNamespace } from "../types";
import type { ErrorCodes } from "@mozioinc/query";

export type GeneralErrorProps = {
  className?: string;
  title?: string;
  message?: string;
  onClick?: () => void;
  error?: ErrorCodes;
  hideIcon?: boolean;
  buttonLabel?: string;
};

export const GeneralError = ({
  className = "",
  title,
  message,
  onClick,
  error,
  hideIcon = false,
  buttonLabel,
}: GeneralErrorProps) => {
  const { t } = useTranslation<TransNamespace>("transfer:error");
  useEffect(() => {
    if (error) {
      captureException(new Error(error));
    }
  }, [error]);

  return (
    <div
      className={`mx-auto grid max-w-lg place-content-center place-items-center gap-y-2 p-5 text-center ${className}`}
    >
      {!hideIcon && <ErrorSvg className="text-[16rem] text-neutral-700" />}
      <h1 className="text-2xl font-bold">
        {title || t("Something went wrong")}
      </h1>
      <p>
        {message ||
          t(
            "We apologize for the inconvenience, but it seems like there was an error processing your request.",
          )}
      </p>
      {onClick ? (
        <Button onClick={onClick} className="mt-4 w-full">
          {buttonLabel || t("Go to home page")}
        </Button>
      ) : (
        <Button className="mt-4 w-full" asChild>
          <PreservedLink href="/">
            {buttonLabel || t("Go to home page")}
          </PreservedLink>
        </Button>
      )}
    </div>
  );
};
